import { pnDueActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [pnDueActions.loadSuccess]: (state, action) => {
        let result;
        result = action.payload.entities.pndue ? action.payload.entities.pndue : {};
        return result;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        let result;
        result = action.payload.pndue.entities.pndue ? action.payload.pndue.entities.pndue : {};
        return result;
    },
    [pnDueActions.markReadSuccess]: (state, action) => {
        state[action.payload].isRead = true;
    },
})


